import { scene } from '../main/scene-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { monsterSelector } from '../ui/monsterSelector-sidecar'
import { testRig_common } from './testRig_common-sidecar'
import { machines } from '../machines/machines-sidecar'
import { worldSettings } from '../models/worldSettings-sidecar'
import { tileMapEditor } from '../editor/tileMapEditor-sidecar'

export const createTestRig_sleep = (x: number, y: number) => {
  let ctx = scene.getContext()

  let w = 14
  let h = 7
  let std = tilesDataShip.getStandard()

  tileMapEditor.setMode('stats')

  worldSettings.setNeedsNull()
  worldSettings.setNeeds({
    energyRate: worldSettings.defaultNeeds.energyRate * 20,
  })

  testRig_common.createBasicShip(x, y)

  let mc = machines.create('bed')
  machines.moveToTile(mc, ctx.mapShip, x + 7, y + 3)

  let m = monsters.create('human', 1)
  monsters.moveToTile(m, ctx.mapShip, x + 4, y + 3)
  m.isInsideShip = true
  monsters.setInSuit(m, false)
  monsterSelector.select(m)
}
